// extracted by mini-css-extract-plugin
export var dayLabel = "_lv-0";
export var pickerDisabled = "_lv-1";